module.exports = __webpack_public_path__ + "static/media/language.47134ddf.jpeg";